/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatcoverhellotitle4Inputs */

const en_aichatcoverhellotitle4 = /** @type {(inputs: Aichatcoverhellotitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cover for your event`)
};

const de_aichatcoverhellotitle4 = /** @type {(inputs: Aichatcoverhellotitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Cover für dein Event`)
};

/**
* | output |
* | --- |
* | "A cover for your event" |
*
* @param {Aichatcoverhellotitle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatcoverhellotitle4 = /** @type {((inputs?: Aichatcoverhellotitle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatcoverhellotitle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatcoverhellotitle4(inputs)
	return de_aichatcoverhellotitle4(inputs)
});
export { aichatcoverhellotitle4 as "aiChatCoverHelloTitle" }